import { Button } from "../../../design/button";
import {
  Alert,
  AlertActions,
  AlertDescription,
  AlertTitle,
} from "../../../design/alert";

interface Props {
  isOpen: boolean;
  onNo: () => void; // Function to call when "No" is clicked
  onYes: () => void; // Function to call when "Yes" is clicked
}

const GenerateTaskRecommendationsAlert: React.FC<Props> = ({
  onNo,
  isOpen,
  onYes,
}) => {
  return (
    <>
      <Alert open={isOpen} onClose={() => onNo()}>
        <AlertTitle>Analyze?</AlertTitle>
        <AlertDescription>
          Would you like Casey to analyze your document and generate task
          recommendations?
        </AlertDescription>
        <AlertActions>
          <Button plain onClick={onNo}>
            No
          </Button>
          <Button color={"green"} onClick={onYes}>
            Yes
          </Button>
        </AlertActions>
      </Alert>
    </>
  );
};

export default GenerateTaskRecommendationsAlert;
